<template>
    <div>
        <div class="filter-header" v-if="type=='product'">
            <ul class="menu">
                <li>
                    <my-cascader :choices="categories" filter-type="category" placeholder="产品"
                                 :selected="filter.category"
                                 @selectChange="filterChange" trigger="hover"></my-cascader>
                </li>
                <li>
                    <my-cascader :choices="styles" filter-type="style" placeholder="风格" :selected="filter.style"
                                 @selectChange="filterChange"></my-cascader>
                </li>
                <li>
                    <color-picker :choices="colors" :selected="filter.color" filter-type="color"
                                  @selectChange="filterChange"
                                  v-if="colors.length" :clearable="true"></color-picker>
                </li>
                <li>
                    <my-cascader :choices="sorts" filter-type="sort" placeholder="排序" :selected="filter.sort"
                                 @selectChange="filterChange"></my-cascader>
                </li>
            </ul>
            <div class="goods-in-stock">
                <Checkbox v-model="single">精选</Checkbox>
            </div>
            <!-- <div class="right-filter" v-if="isLogin && (!isZhulogic || (user.type === 2 || user.type === 3 || user.isVip === 1))">
                <div class="price">
                    <div class="inner">
                        <span class="label">价格</span>
                        <span class="price-input"><input type="number" placeholder="¥" v-model="filter.minPrice"
                                                         class="bg-grey"></span>
                        <span> - </span>
                        <span class="price-input"><input type="number" placeholder="¥" v-model="filter.maxPrice"
                                                         class="bg-grey"></span>
                        <button class="red-btn confirm-btn" @click="updatePageDate">确定</button>
                    </div>
                </div>
            </div> -->
        </div>
        <div class="filter-header" v-if="type=='plan'">
            <ul class="menu">
                <li>
                    <my-cascader :choices="roomTypes" filter-type="roomType" placeholder="空间"
                                 :selected="filter.roomType"
                                 @selectChange="filterChange"></my-cascader>
                </li>
                <li>
                    <my-cascader :choices="styles" filter-type="style" placeholder="风格" :selected="filter.style"
                                 @selectChange="filterChange"></my-cascader>
                </li>
                <li>
                    <my-cascader :choices="sorts" filter-type="sort" placeholder="排序" :selected="filter.sort"
                                 @selectChange="filterChange"></my-cascader>
                </li>
            </ul>
        </div>
    </div>
</template>
<script>
    import {mapGetters} from 'vuex'
    import util from '../../libs/util'
    import config from '../../config/config'
    import myCascader from './myCascader.vue'
    import colorPicker from './colorPicker.vue'

    export default {
        data(){
            return {
                single: util.getUrlHash().stockStatus === '1',
                isZhulogic: config.isZhulogic
            }
        },
        props:{
            filter:{
                type:Object
            },
            type:{
                type:String,
                default:'product'
            }
        },
        components: {
            myCascader,
            colorPicker,
        },
        computed: {
            ...mapGetters([
                'categories',
                'styles',
                'sorts',
                'colors',
                'roomTypes',
                'sorts'
            ]),
            user() {
                return this.$store.state.user.info;
            },
            isLogin() {
                return this.$store.state.user.token;
            },
        },
        watch: {
            single: function () {
                this.filter['stockStatus'] = this.single ? '1' : '';
                this.updatePageDate();
            }
        },
        methods: {
            filterChange(type, value) {
               this.filter[type] = value;
               this.$emit('filterChange',this.filter)
            },
            updatePageDate() {
                this.$emit('updatePage')
            },
        },
        created(){
            this.filter['stockStatus'] = this.single ? '1' : '';
            this.filter['pageNum'] = 1;
            this.updatePageDate();
        }
    }
</script>
<style scoped type="text/scss" lang="scss">
    .filter-header {
        height: 60px;
        line-height: 60px;
        >div{
            line-height: 60px;
        }
        .goods-in-stock {
            float: right;
        }
        >ul.menu {
            display: inline-block;
            vertical-align: middle;
            &:after {
                content: '';
                clear: both;
            }
            > li {
                float: left;
                width: 110px;
                margin-right: 54px;
                >div{
                    line-height: 32px;
                    display:inline-block;
                    vertical-align: middle;
                }
            }
        }
        .right-filter {
            float: right;
            margin-right: 60px;
            > div {
                display: inline-block;
                vertical-align: middle;
            }
            * {
                font-size: 14px;
            }
            .price {
                cursor: pointer;
                width: 210px;
                height: 44px;
                position: relative;
                .inner {
                    position: absolute;
                    top: -1px;
                    left: -1px;
                    width: 100%;
                    height: 44px;
                    line-height: 44px;
                    padding: 0 12px;
                    z-index: 3;
                }
                .confirm-btn {
                    margin-left: 9px;
                    display: none;
                }
                &:hover {
                    .inner {
                        width: 260px;
                        background: #DCE0E0;
                    }
                    .confirm-btn {
                        display: inline-block;
                    }
                }
            }
            .label {
                margin-right: 8px;
            }
            .price-input {
                height: 24px;
                line-height: 24px;
                position: relative;
                width: 64px;
                display: inline-block;
                vertical-align: middle;
            }
            .price {
                &:hover input {
                    background-color: #fff;
                }
                input {
                    border-radius: 4px;
                    border: 0 none;
                    box-shadow: none;
                    height: 24px;
                    width: 64px;
                    padding: 0 4px;
                }
            }
            .stock {
                .check-box {
                    position: relative;
                    display: inline-block;
                    width: 12px;
                    height: 12px;
                    margin-left: 10px;
                    vertical-align: middle;
                }
                > span {
                    vertical-align: middle;
                }
                input[type=checkbox] {
                    width: 100%;
                    height: 100%;
                    position: absolute;
                    top: 0;
                    bottom: 0;
                    left: 0;
                    right: 0;
                    z-index: 3;
                    cursor: pointer;
                    opacity: 0;
                }
                .checkbox-rep {
                    background: #FFFFFF;
                    border: 1px solid #6C6F70;
                    border-radius: 2px;
                    position: absolute;
                    top: 0;
                    bottom: 0;
                    left: 0;
                    right: 0;
                    i {
                        font-size: 12px;
                        transform: scale(0.7);
                        position: absolute;
                        top: 0;
                        left: -2px;
                        height: auto;
                        line-height: 12px;
                    }
                }
            }
        }
    }
    @media screen and (max-width: 1799px) {
        .sub-page .header-title,
        .sub-page .page-content,
        .sub-page .filter-header {
            width: 1200px;
            margin: 0 auto;
        }

        .sub-page .list {
            width: 1220px;
            margin: 0 auto;
        }
    }
    @media screen and (min-width: 1800px) {
        .sub-page .header-title,
        .sub-page .page-content,
        .sub-page .filter-header {
            width: 1800px;
            margin: 0 auto;
        }

        .sub-page .list {
            width: 1820px;
            margin: 0 auto;
        }

        .sub-page .page-content.information {
            width: 1200px;
        }
    }
</style>